<template>
  <div>
    <appheader index="0"></appheader>
    <zlf-search></zlf-search>
    <about></about>
    <!-- <router-view></router-view> -->
    <bottom></bottom>
  </div>
</template>
<script>
import Appheader from "./moudel/Appheader";
import zlfSearch from "./moudel/zlfSearch";
import bottom from "./bady_bottom/bottom";
import about from "./zlfList.vue";
// import Appbody from './moudel/Appbody'
export default {
  inject: ["reload"],
  name: "home",
  data() {
    return {};
  },
  beforeRouteLeave(to, from, next) {
    // 从列表页去到别的页面，如果不是详情页，则不缓存列表页
    if (to.name != "order") {
      this.$route.meta.keepAlive = false;
      this.$route.meta.flag = false;
    } else {
      this.$route.meta.keepAlive = true;
      this.$route.meta.flag = false;
    }
    next();
  },
  components: {
    Appheader,
    zlfSearch,
    bottom,
    about,
  },
  methods: {},
  mounted() {
    console.log("5555", JSON.parse(localStorage.getItem("userData")));
  },
};
</script>
